import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;
export const getOverviewCompetitorTable: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) => {
  const obj: any = {
    url: `${prefix}/overview/competitor_stats_list`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<overviewOriginType>;
};

export const getOverviewCompetitorTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> = (payload, cancelTokenFunc = c => {}) => {
  const obj: any = {
    url: `${prefix}/overview/competitor_stats_timeline`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<overviewOriginType>;
};
